module.exports = __webpack_public_path__ + "media/images/bsmart/icons/side_menu_report-4ce17119bd512a7d876c6c84ad8663e3.svg";